import React from 'react';

import Room from '../room';

import TS1 from './images/triple-superior.1.jpg';
import TS2 from './images/triple-superior.2.jpg';
import TS3 from './images/triple-superior.3.jpg';
import TS4 from './images/triple-superior.4.jpg';
import TS5 from './images/triple-superior.5.jpg';
import TS6 from './images/triple-superior.6.jpg';

const TripleSuperior = () => {

  const images = [
    { original: TS1, thumbnail: TS1 },
    { original: TS2, thumbnail: TS2 },
    { original: TS3, thumbnail: TS3 },
    { original: TS4, thumbnail: TS4 },
    { original: TS5, thumbnail: TS5 },
    { original: TS6, thumbnail: TS6 },
  ];

  return (
    <Room title="Triple Superior" images={images} capacity={4}>
      <p className="p-services">Cómoda habitación con vistas a la calle. Posibilidad de ser twin o matrimonial + cama.</p>
      <p className="p-services">Equipada con TV por cable, WiFi, cofre de seguridad, calefacción central, aire acondicionado frío/calor, mini bar.</p>
    </Room>
  );
};

export default TripleSuperior;



// WEBPACK FOOTER //
// ./src/rooms/triple-superior/index.js